/**
 *    @author:
 *    @since:
 *
 */

import { Component, HostListener, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import { Router } from '@angular/router';
import { TimerService } from 'src/refresh/service/timer-service';
import { FormBaseComponent } from '../_common/component/form-base.component';
import { InputData, ParentInfo, SIN } from '../_common/data/input-data';
import { GAData, Path, Progress } from  "../_common/constant/page-const";
import { SINMainValidation } from './SIN_main.validator';
import { LightBox }   from '../../refresh/layout/light-box/light-box.component';
import { ViewportScroller } from '@angular/common';
import { Util } from 'src/refresh/service/Util';
import { ProgressService } from 'src/refresh/service/progress-service';
import { Confirm } from 'src/refresh/service/constant';
import { CommonService } from 'src/refresh/service/common-service';

@Component({ 
      selector: 'SIN_main',
      templateUrl: './SIN_main.component.html',
      styleUrls: ['./SIN_main.component.less'],
      //encapsulation: ViewEncapsulation.None
})
export class SINMainComponent extends FormBaseComponent implements OnInit {

      public sin: SIN;
      public childNameParam: Object;
      public parentCount: number;
      ////public parents:ParentInfo[];
      SINMainValidation:SINMainValidation;
      isOpened:boolean = false;
     
      public error_chkParents: string = "";
      public error_chkRead: string = "";
      public error_chkCertify: string  = "";

      @ViewChild(LightBox) box1: LightBox;

       constructor( protected router: Router,
                    public timerService:TimerService,
                    public data:InputData,
                    protected progress:ProgressService,
                    public viewportScroller: ViewportScroller,
                    private commonService: CommonService ) {

                    super(router,timerService);  

                    let prevPage = !this.data.CCB.chk_consent? Path.CCBAreYouSure
                                                             : Path.CCBMain;
                    super.setNextPage(Path.ESRMain,prevPage);

                    if ( this.data.eligibility.listedParentCount <= 2 ) {
                        for ( let i = 0; i < this.data.eligibility.listedParentCount; i++ ) 
                              this.data.parentList[i].isSINParent = true;
                    }
      
                    this.sin = this.data.SIN;
      
                    if ( this.sin.chk_certify == 'X' ) {
                         this.sin.chk_certify = '';
                         super.forward();
                         return;
                    }
      
                    this.SINMainValidation = new SINMainValidation(this,this.viewportScroller,Progress.SIN);
                    super.setValidator(this.SINMainValidation);
      
                    this.setLocalFieldFromData(this.data);
                    
                    this.childNameParam = { childName: this.data.aboutChild.name.getFullName() };
                    this.SINMainValidation.checkParents();
      
                    this.commonService.getCloseLightBox().subscribe((r) =>{
                        if(this.isOpened) this.onMyClose();
                    });
      
                    InputData.currentPageIdx = 21;
                    if ( InputData.moveNext == 0 || InputData.moveNext == InputData.currentPageIdx ) this.timerService.isForwarding = false;
       }

       public ngOnInit() {
       	  super.forwardNext(this.data.eligibility.listedParentCount);
       }

       private setLocalFieldFromData(data:InputData) {
            this.parentCount = data.eligibility.listedParentCount;
            //this.parentCount = data.eligibility.certifyingParentCount;
            ///this.parents = data.parents; 

       }


       parentCheck(){
            return this.SINMainValidation.checkParents();
       }

       onMyClick(event: MouseEvent) {

            if( this.SINMainValidation.chk() != 2
             && this.parentCount > 2 ){
                  event.preventDefault();
                  this.SINMainValidation.noticeError();
                  var el = document.getElementById("parents").offsetTop;
                  window.scrollTo(0, el);
                  let ctrl = document.getElementById('chkbox_parentsCheckbox0');
                  ctrl.focus();   
            }else {
                  event.preventDefault();
                  this.box1.open();
                  this.isOpened = true;
            }
       }

       onMyClose() { 
            this.data.SIN.chk_read = false; 
            this.box1.close();
            this.isOpened = false;
       }   

       @HostListener('document:keydown.escape', ['$event'])
       public escape(){
             if(this.isOpened) {
                   this.onMyClose();
             }
      }

       public keyPress(event:any) {
            if ( event.keyCode == 13 ) {
                  this.onMyClose();
          }
      }

       parentAgree(){
            this.box1.close();
            this.data.SIN.chk_read = true;
            this.error_chkRead = "";
            this.isOpened = false;
       }

       onNextClick(): boolean {

              if ( super.onNextClick() )
                   super.gtag(GAData.Button,GAData.continue_product);
                
              return true;
       }
       
       notApply() {

               this.timerService.reset();
               this.router.navigate([Path.SINAreYouSure]);

               this.progress.progressStatus[Progress.SIN] = 4;

               super.gtag(GAData.Button,GAData.no_BC);
       }
}
